<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Касса</div>
                  <div class="breadcrumb">Касса</div>
                </div>
              </v-col>
              <v-col
                  cols="6"
              >
                <v-alert
                    v-if="error.dialog"
                    type="error"
                    dismissible
                >
                  {{ error.msg }}
                </v-alert>
              </v-col>
              <v-col
                  class="d-flex justify-space-between"
                  cols="12"
              >
                <div class="d-flex align-center">
                  <div class="page-subtitle" style="padding-right: 15px; margin-top: 0 !important;">
                    Касса
                  </div>
                  <v-select
                      v-model="select_cashbox"
                      :items="listCashbox"
                      item-text="legal_entity"
                      item-value="serial"
                      class="rounded-lg"
                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                      label="Выбрать"
                      append-icon="mdi-chevron-down"
                      outlined
                      hide-details
                      dense
                      required
                      color="#629F33"
                      background-color="#fff"
                      style="max-width: 240px !important;"
                  ></v-select>
                </div>
                <div v-if="cashbox && select_cashbox">
                  <v-btn
                      v-if="!cashbox.opened && !opened"
                      color="#629F33"
                      class="button__lighten-success"
                      @click="openShift"
                      :disabled="isLoading"
                  >
                    Открыть смену
                  </v-btn>
                  <v-btn
                      v-else
                      color="#629F33"
                      class="button__lighten-success"
                      @click="closeShift"
                      :disabled="isLoading"
                  >
                    Закрыть смену
                  </v-btn>
                </div>
              </v-col>

              <v-container class="white lighten-5 mt-5 rounded-lg">
                <div class="card-title">
                  Наличные
                </div>
                <v-row
                    v-for="j in justify"
                    :key="j"
                    :justify="j"
                >
                  <v-col
                      md="3"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{
                            (select_cashbox && cashbox && cashbox.cashbox && cashbox.cashbox.cashbox && cashbox.cashbox.cashbox.sum_start) ? cashbox.cashbox.cashbox.sum_start + ' ₽' : '0 ₽'
                          }}</span><br>
                        <span class="caption_2">Начало</span>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                      md="3"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{
                            (select_cashbox && cashbox && cashbox.cashbox && cashbox.cashbox.cashbox && cashbox.cashbox.cashbox.sum_in) ? cashbox.cashbox.cashbox.sum_in + ' ₽' : '0 ₽'
                          }}</span><br>
                        <span class="caption_2">Приход</span>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                      md="3"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{
                            (select_cashbox && cashbox && cashbox.cashbox && cashbox.cashbox.cashbox && cashbox.cashbox.cashbox.sum_out) ? cashbox.cashbox.cashbox.sum_out + ' ₽' : '0 ₽'
                          }}</span><br>
                        <span class="caption_2">Расход</span>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                      md="3"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{
                            (select_cashbox && cashbox && cashbox.cashbox && cashbox.cashbox.cashbox && cashbox.cashbox.cashbox.sum_end) ? cashbox.cashbox.cashbox.sum_end + ' ₽' : '0 ₽'
                          }}</span><br>
                        <span class="caption_2">Итого</span>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-col
                    v-if="cashbox && select_cashbox && (cashbox.opened || opened)"
                    class=" d-flex justify-space-between"
                    cols="12"
                >
                  <div class="mt-5">
                    <v-btn
                        dark
                        class="filter-button"
                        @click="dialogCashIn = true"
                    >
                      Внести наличные
                    </v-btn>
                    <v-btn
                        dark
                        class="filter-button"
                        @click="dialogCashOut = true"
                    >
                      Изъять наличные
                    </v-btn>
                  </div>
                  <div v-if="cashbox && select_cashbox && (cashbox.opened || opened)">
                    <v-btn
                        color="#629F33"
                        class="button__lighten-success mr-3"
                        @click="Zreport"
                        :disabled="isLoading"
                    >
                      Z отчет
                    </v-btn>

                    <v-btn
                        color="#629F33"
                        class="button__lighten-success"
                        @click="Xreport"
                        :disabled="isLoading"
                    >
                      X отчет
                    </v-btn>
                  </div>
                </v-col>
              </v-container>
              <v-container
                  class="white lighten-5 mt-5 rounded-lg"
                  v-if="cashbox && select_cashbox && (cashbox.opened || opened)"
              >
                <v-col
                    class=" d-flex justify-end"
                    cols="12"
                >
                  <div>
                    <v-btn
                        color="#629F33"
                        class="button__lighten-success"
                        style="margin-top: 0 !important;"
                        @click="closeAcq"
                        :disabled="isLoading"
                    >
                      Сверка отчета
                    </v-btn>
                  </div>
                </v-col>
                <v-row
                    v-for="terminal in cashbox.cashbox.terminals"
                    :key="terminal.id"
                >
                  <v-col
                      md="12"
                  >
                    <div class="card-title" style="margin: 0 !important;">
                      {{ terminal.name }}
                    </div>
                  </v-col>
                  <v-col
                      md="6"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{ terminal.sum_in }} ₽</span><br>
                        <span class="caption_2">Приход</span>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                      md="6"
                  >
                    <v-card
                        class="pa-2 text-center rounded-lg"
                        outlined
                        tile
                    >
                      <div class="text-cash-block">
                        <span class="caption_1">{{ terminal.sum_out }} ₽</span><br>
                        <span class="caption_2">Расход</span>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCashIn"
              persistent
              max-width="460px"
          >
            <v-card rounded="lg">
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Внесение наличных</h4>
                </div>
                <v-btn icon @click="dialogCashIn = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" @submit.prevent="summInSubmit">
                    <v-row>
                      <v-col
                          cols="12"
                      >
                        <v-alert
                            v-if="error.dialog"
                            type="error"
                            dismissible
                        >
                          {{ error.msg }}
                        </v-alert>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <label>Сумма <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="summ_in"
                            :rules="summRules"
                            placeholder="0"
                            type="number"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <div class="text-center">
                          <v-chip
                              class="ma-2"
                              @click="summ_in = 10000"
                          >
                            10 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_in = 25000"
                          >
                            25 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_in = 50000"
                          >
                            50 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_in = 100000"
                          >
                            100 000 ₽
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                            style="width: calc(100% - 0px)!important;"
                            :disabled="isLoading"
                        >
                          Внести
                        </button>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="dialogCashOut"
              persistent
              max-width="460px"
          >
            <v-card rounded="lg">
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Изьять наличные</h4>
                </div>
                <v-btn icon @click="dialogCashOut = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" @submit.prevent="summOutSubmit">
                    <v-row>
                      <v-col
                          cols="12"
                      >
                        <v-alert
                            v-if="error.dialog"
                            type="error"
                            dismissible
                        >
                          {{ error.msg }}
                        </v-alert>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <label>Сумма <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="summ_out"
                            :rules="summRules"
                            type="number"
                            placeholder="0"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <div class="text-center">

                          <v-chip
                              class="ma-2"
                              @click="summ_out = 10000"
                          >
                            10 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_out = 25000"
                          >
                            25 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_out = 50000"
                          >
                            50 000 ₽
                          </v-chip>
                          <v-chip
                              class="ma-2"
                              @click="summ_out = 100000"
                          >
                            100 000 ₽
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                            style="width: calc(100% - 0px)!important;"
                            :disabled="isLoading"
                        >
                          Изъять
                        </button>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {mapState} from "vuex";
import {clientActionTypes} from '@/store/modules/client';
import {cashboxActionTypes} from '@/store/modules/cashbox';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {getItem, setItem} from "@/helpers/persistanceStorage";

export default {
  name: "Clients",
  components: {
    Header,
    Menu
  },
  data() {
    return {
      justify: [
        'start',
      ],
      error: {
        dialog: false,
        msg: ''
      },
      select_cashbox: null,
      counterInterval: null,
      id: true,
      closed: true,
      opened: false,
      summ_in: 0,
      summ_out: 0,
      summRules: [
        v => !!v || 'Сумма обязательное поле'
      ],
      dialogCashIn: false,
      dialogCashOut: false,
      dialogError: false,
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? [],
      zconfirmed:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      cashbox: state => state.cashbox.cashbox,
      validationErrors: state => state.cashbox.validationErrors,
      userFIO: state => state.userFIO, //Фио пользователя
    })
  },
  methods: {
    summInSubmit() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.cashIn, {
        till_id: this.select_cashbox,
        summ: Math.abs(this.summ_in),
        fio: this.userFIO
      }).then((res) => {
        if (res.success) {
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            this.dialogCashIn = false
          })
        } else {
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    summOutSubmit() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.cashOut, {
        till_id: this.select_cashbox,
        summ: Math.abs(this.summ_out),
        fio: this.userFIO
      }).then((res) => {
        if (res.success) {
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            this.dialogCashOut = false
          })
        } else {
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    openShift() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.openShift, {
        till_id: this.select_cashbox,
        fio: this.userFIO
      }).then((res) => {
        if (res.success) {
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            this.opened = true
          })
        } else {
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    closeShift() {
      if(this.opened && !this.zconfirmed){
        alert('Не снят Z-отчёт!')
      } else {
        this.error.dialog = false;
        this.$store.dispatch(cashboxActionTypes.closeShift, {
          till_id: this.select_cashbox
        }).then((res) => {
          console.log(res)
          if (res.success) {
            setItem('select_org-sale',null)
            this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
              till_id: this.select_cashbox
            }).then(() => {
              this.opened = false
            })
          } else {
            this.error.dialog = true;
            if(res && res.error && res.error.split('закрыта')[1]){
              this.opened = false
            }
            this.error.msg = res.error;
          }
        })
      }
    },
    closeAcq() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.closeAcq, {
        till_id: this.select_cashbox
      }).then((res) => {
        if (res.success) {
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            this.opened = false
          })
          alert('Сверка успешно запущена');
        } else {
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    Xreport() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.xReport, {
        till_id: this.select_cashbox
      }).then((res) => {
        if (res.success) {
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            this.opened = false
          })
        } else {
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    Zreport() {
      this.error.dialog = false;
      this.$store.dispatch(cashboxActionTypes.zReport, {
        till_id: this.select_cashbox
      }).then((res) => {
        if (res.success) {
          this.zconfirmed = true
          this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
            till_id: this.select_cashbox
          }).then(() => {
            //this.opened = false
          })
        } else {
          alert('Ошибка Z отчёта!')
          this.error.dialog = true;
          this.error.msg = res.error;
        }
      })
    },
    collectData(selected) {
      this.selected.push(selected)
      this.dialogButton = true;
    },
    clearData() {
      this.$refs.form.reset();
      this.selected.length = 0;
      this.dialogButton = false;
    }
  },
  mounted() {
    //this.fetchFeed();
    console.log(this.userFIO)
    setItem('sales-monitor-specialist_id', null);
    setItem('sales-monitor-specialist_type', null);
    setItem('sales-monitor-datetype', null);
    setItem('sales-monitor-datetype_date', null);
  },
  watch: {
    select_cashbox() {
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: this.select_cashbox
      })
    }
  }
}
</script>

<style scoped>
.caption_1 {
  color: var(--dl-color-text-text);
  height: auto;
  align-self: auto;
  text-align: center;
  line-height: 32px;
  margin-right: 0;
  margin-bottom: 2px;
  font-weight: bold;
  font-size: 22px;
}

.caption_2 {
  color: var(--dl-color-text-text);
  height: auto;
  align-self: auto;
  line-height: 24px;
  margin-right: 0;
  margin-bottom: 0;
  display: block;
  text-align: center;
}

.text-cash-block {
  padding-top: 40px;
  height: 158px;
}

.card-title {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 15px 0;
}
</style>